var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVolumeMax = function SvgIconVolumeMax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 33h9l7.758 7.759a4.243 4.243 0 0 0 7.242-3V10.243a4.242 4.242 0 0 0-7.242-3L13.5 15h-9A4.5 4.5 0 0 0 0 19.5v9A4.5 4.5 0 0 0 4.5 33m37.986 6.31c-.795.957-2.229.95-3.108.072-.876-.88-.864-2.298-.093-3.27A19.4 19.4 0 0 0 43.5 24a19.4 19.4 0 0 0-4.215-12.108c-.771-.975-.783-2.391.096-3.27.876-.88 2.31-.885 3.105.072A23.9 23.9 0 0 1 48 24c0 5.82-2.07 11.154-5.514 15.309m-6.414-6.405c-.738.999-2.178.99-3.057.11-.879-.875-.852-2.291-.18-3.335A10.5 10.5 0 0 0 34.5 24a10.46 10.46 0 0 0-1.665-5.675c-.672-1.044-.699-2.46.18-3.34.879-.878 2.319-.887 3.06.115A14.93 14.93 0 0 1 39 24a14.94 14.94 0 0 1-2.928 8.905",
    clipRule: "evenodd"
  })));
};
export default SvgIconVolumeMax;